import { render, staticRenderFns } from "./DistributionSpecificPercentageAlternatives.vue?vue&type=template&id=222bfbf4&scoped=true"
import script from "./DistributionSpecificPercentageAlternatives.vue?vue&type=script&lang=js"
export * from "./DistributionSpecificPercentageAlternatives.vue?vue&type=script&lang=js"
import style0 from "./DistributionSpecificPercentageAlternatives.vue?vue&type=style&index=0&id=222bfbf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222bfbf4",
  null
  
)

export default component.exports